import Icon from '~/components/Icon/Icon';
import PulseProperties from '~/components/properties/PulseProperties/PulseProperties';
import Collapsible from '~/components/widgets/Collapsible/Collapsible';
import { useExperiment } from '~/systems/experiment';
import { useUiState } from '~/systems/uiState';
import './PulseControl.css';

interface PulseControlProps {
  initialState: boolean;
}

export default function PulseControl({ initialState }: PulseControlProps) {
  const uiState = useUiState();
  const { pulses } = useExperiment();

  return (
    <div className="PulseControl">
      <Collapsible
        initialState={initialState}
        button={() => (
          <h3 className="PulseControl-sectionTitle">
            <Icon kind="activity" />
            Pulse
          </h3>
        )}
        items={
          <div className="PulseControl-sectionBody">
            {pulses.map((pulse) => (
              <PulseProperties
                key={pulse.uuid}
                pulse={pulse}
                pulseUuid={pulse.uuid}
                selectedPulse={uiState.pulseSelection.has(pulse.uuid)}
              />
            ))}
          </div>
        }
      />
    </div>
  );
}
